import React from "react";
import {
  Chart,
  ExpandableWrapper,
  InfoCardNew,
} from "../../../../../components";

const ExpandableWrapperList = () => {
  return (
    <div className="flex gap-6">
      <ExpandableWrapper expandedContent={""} datepicker title="Revenue Chart" >
        <Chart
          noTitle
          steps={5}
          data={[
            { label: "0-30", value: 4 },
            { label: "30-60", value: 12 },
            { label: "60-90", value: 16 },
            { label: "90-120", value: 25 },
            { label: "120-150", value: 18 },
          ]}
          formatYAxisTick={(val) => `$ ${val}`}
        />
      </ExpandableWrapper>
      <ExpandableWrapper
        expandedContent={
          <div className="grid grid-cols-5 gap-6 mx-4">
            <InfoCardNew title="Total Accounts" value={9999} backValue={7645} />
            <InfoCardNew
              title="Total Accounts 1"
              value={1326}
              backValue={5645}
            />
            <InfoCardNew
              title="Total Accounts 2"
              value={4343}
              backValue={1234}
            />
            <InfoCardNew
              title="Total Accounts 3"
              value={4536}
              backValue={6765}
            />
            <InfoCardNew
              title="Total Accounts 4"
              value={9083}
              backValue={4365}
            />
          </div>
        }
        title="Sales Chart"
      >
        <Chart
          type="areachart"
          noTitle
          steps={5}
          data={[
            { label: "0-30", value: 4 },
            { label: "30-60", value: 12 },
            { label: "60-90", value: 16 },
            { label: "90-120", value: 25 },
            { label: "120-150", value: 18 },
          ]}
          formatYAxisTick={(val) => `$ ${val}`}
        />
      </ExpandableWrapper>
    </div>
  );
};

export default ExpandableWrapperList;
